import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Registration } from './registration.model';

@Injectable()
export class RegistrationService {
    constructor(private http: HttpClient) {}

    findAll(): Observable<Registration[]> {
        return this.http.get<Registration[]>('/api/registrations');
    }

    findById(id): Observable<Registration> {
        return this.http.get<Registration>('/api/registrations/' + id);
    }

    update(registration) {
        return this.http.put('/api/registrations', registration);
    }

    create(registration) {
        return this.http.post('/api/registrations', registration);
    }

    delete(id) {
        return this.http.delete('/api/registrations' + id);
    }

    createTrainingSessionCompany(trainingSessionCompany) {
        return this.http.post(
            '/api/training-session-company',
            trainingSessionCompany
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/registration/registration.service.ts